import React, { Component } from 'react'
import * as Sentry from '@sentry/react'
import errorInfo from './assets/images/icons/error-info.svg'


class ReactErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  // eslint-disable-next-line no-unused-vars
  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by ReactErrorBoundary:', error, errorInfo)
    Sentry.captureException(error, { extra: { componentStack: errorInfo.componentStack } })
  }

  render() {
    if (this.state.hasError) {
      // Render fallback UI when an error occurs
      return (
        <div>
          <div className="error-info-sec">
            <div className="error-logo-img"><img src={errorInfo} alt="Error Info" /></div>
            <div className="error-heading">Oops!</div>
            <div className="error-subheading">Something went wrong.</div>
            <div className="error-btn">
              <button className="dd-button-cta--primary-alt">Back to Home</button>
            </div>
          </div>
          {/* You can customize the error message or UI as needed */}
        </div>
      )
    }

    // Render the children components as usual
    return this.props.children
  }
}

export default ReactErrorBoundary
